import {useContext, useEffect, useState} from 'react';
import {useTranslation} from 'react-i18next';
import axios from '../../../common/axios';
import ThemeContext from '../../../contexts/themeContext';
import useDarkMode from '../../../hooks/useDarkMode';
import Aside, {AsideBody, AsideFoot, AsideHead} from '../../../layout/Aside/Aside';
import Brand from '../../../layout/Brand/Brand';
import Navigation from '../../../layout/Navigation/Navigation';
import User from '../../../layout/User/User';
import {TIcons} from '../../../type/icons-type';
import {useNavigate} from 'react-router-dom';

const DefaultAside = () => {
    const {asideStatus, setAsideStatus} = useContext(ThemeContext);
    const navigate = useNavigate();
    const [doc, setDoc] = useState(
        localStorage.getItem('facit_asideDocStatus') === 'true' || false,
    );
    const [menus, setMenus] = useState({});

    const {t} = useTranslation(['translation', 'menu']);
    var isLoading = true;

    const {darkModeStatus} = useDarkMode();
    type MenuItem = {
        id?: string | number;
        text?: string;
        path?: string;
        icon?: TIcons;
        isDisable?: boolean;
        subMenu?:
            | {
            id?: string | number;
            text?: string;
            path?: string;
            icon?: TIcons;
            isDisable?: boolean;
        }[]
            | undefined;
    };

    const fetchMenu = async () => {
        const response = await axios.get("menu").then((res) => {
            return res;
        }).catch((err) => {
            //rebuild
            return err;
        })
        if (response?.response?.data?.code === 451
        ) {
            if(window.location.pathname !== '/forgot-password')
                return navigate('/forgot-password');
        }
        var menu1: {
            [key: string]: {
                id?: string | number;
                text?: string;
                path?: string;
                icon?: TIcons;
                isDisable?: boolean;
                subMenu?: {
                    [key: string]: {
                        id?: string | number;
                        text?: string;
                        path?: string;
                        icon?: TIcons;
                        isDisable?: boolean;
                    };
                } | null
            }
        } = {};
        var stt = 0;
        response.data.result.forEach((i: any) => {
            if (i.subMenu && i.subMenu.length > 0) {
                var menu2: {
                    [key: string]: {
                        id?: string | number;
                        text?: string;
                        path?: string;
                        icon?: TIcons;
                        isDisable?: boolean;
                    }
                } = {};
                i.subMenu.forEach((j: any) => {
                    //console.log(i.title,j)
                    stt++;
                    menu2["m" + stt] = {
                        id: j.ID,
                        text: j.title,
                        icon: j.icon,
                        path: j.pageName
                    };
                });
                menu1["m" + stt] = {
                    id: i.ID,
                    text: i.title,
                    icon: i.icon,
                    subMenu: menu2,
                    path: i.pageName == null ? i.ID : i.pageName,
                }
            } else {
                menu1["m" + stt] = {
                    id: i.ID,
                    text: i.title,
                    icon: i.icon,
                    path: i.pageName == null ? i.ID : i.pageName,
                }
            }
            stt++;
        });
        //console.log(menu1)

        setMenus(menu1);

    };

    useEffect(() => {
        fetchMenu();
    }, []);

    return (
        <Aside>
            <AsideHead>
                <Brand asideStatus={asideStatus} setAsideStatus={setAsideStatus}/>
            </AsideHead>
            <AsideBody>
                {!doc && (
                    <>
                        <Navigation menu={menus} id='aside-dashboard'/>
                    </>
                )}
            </AsideBody>
            <AsideFoot>
                <User/>
            </AsideFoot>
        </Aside>
    );
};

export default DefaultAside;
